'use es6';

import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
import Client from 'AdsUI/data/Client';
import calculateTimeRange from 'AdsUI/lib/CalculateTimeRange';
import { EntityStatusMap, EntityTypes, getContactsStatus, ContactListFunnelStage } from 'AdsUI/lib/Constants';
import { getListsClientEndpointPath, handleContactListCreationRequest } from 'AdsUI/lib/ContactList';
export default {
  fetchContactsByNetwork(_ref) {
    let {
      entityType,
      network,
      funnelStage = ContactListFunnelStage.CONVERSION,
      timeRange,
      attributionView,
      campaignId,
      accountId,
      keywordId,
      adGroupId,
      adId,
      offset,
      limit
    } = _ref,
        contactOpts = _objectWithoutPropertiesLoose(_ref, ["entityType", "network", "funnelStage", "timeRange", "attributionView", "campaignId", "accountId", "keywordId", "adGroupId", "adId", "offset", "limit"]);

    if (!entityType) {
      throw new Error('Entity type is required');
    }

    const baseUrl = `ads/v1/contacts/${network.toLowerCase()}/account/${accountId}/campaign/${campaignId}`;
    let contactsUrl;

    switch (entityType) {
      case EntityTypes.CAMPAIGN:
        contactsUrl = baseUrl;
        break;

      case EntityTypes.ADGROUP:
        contactsUrl = `${baseUrl}/adgroup/${adGroupId}`;
        break;

      case EntityTypes.AD:
        contactsUrl = `${baseUrl}/adgroup/${adGroupId}/ad/${adId}`;
        break;

      case EntityTypes.KEYWORD:
        contactsUrl = `${baseUrl}/adgroup/${adGroupId}/keyword/${keywordId}`;
        break;

      default:
        throw new Error(`Unknown entity type ${entityType}`);
    }

    return Client.apiRequest(contactsUrl, {
      query: Object.assign({}, contactOpts, {}, calculateTimeRange(timeRange), {
        funnelStage,
        attributionType: attributionView,
        offset,
        limit
      })
    });
  },

  fetchAllContacts({
    funnelStage = ContactListFunnelStage.CONVERSION,
    timeRange,
    attributionView,
    opts = {},
    status = Object.keys(EntityStatusMap),
    limit
  }) {
    const contactsUrl = `ads/v1/contacts/all`;

    if (typeof status === 'string') {
      status = [getContactsStatus(status)];
    } else if (!Array.isArray(status)) {
      status = status.map(s => getContactsStatus(s)).toJS();
    }

    return Client.apiRequest(contactsUrl, {
      query: Object.assign({}, opts, {}, calculateTimeRange(timeRange), {
        funnelStage,
        status,
        attributionType: attributionView,
        limit
      })
    });
  },

  createContactListByNetwork(_ref2, hasListsClientMigrationGate = false) {
    let {
      entityType,
      network,
      funnelStage = ContactListFunnelStage.CONVERSION,
      timeRange,
      attributionView,
      campaignId,
      accountId,
      keywordId,
      adGroupId,
      adId
    } = _ref2,
        contactOpts = _objectWithoutPropertiesLoose(_ref2, ["entityType", "network", "funnelStage", "timeRange", "attributionView", "campaignId", "accountId", "keywordId", "adGroupId", "adId"]);

    if (!entityType) {
      throw new Error('Entity type is required');
    }

    const baseUrl = `ads/v1/${getListsClientEndpointPath(hasListsClientMigrationGate)}/${network.toLowerCase()}/account/${accountId}/campaign/${campaignId}`;
    let contactsUrl;

    switch (entityType) {
      case EntityTypes.CAMPAIGN:
        contactsUrl = baseUrl;
        break;

      case EntityTypes.ADGROUP:
        contactsUrl = `${baseUrl}/adgroup/${adGroupId}`;
        break;

      case EntityTypes.AD:
        contactsUrl = `${baseUrl}/adgroup/${adGroupId}/ad/${adId}`;
        break;

      case EntityTypes.KEYWORD:
        contactsUrl = `${baseUrl}/adgroup/${adGroupId}/keyword/${keywordId}`;
        break;

      default:
        throw new Error(`Unknown entity type ${entityType}`);
    }

    return handleContactListCreationRequest(Client.apiRequest(contactsUrl, {
      type: 'PUT',
      query: Object.assign({}, contactOpts, {}, calculateTimeRange(timeRange), {
        attributionType: attributionView,
        funnelStage
      })
    }), contactOpts.listName);
  },

  createContactList(funnelStage = ContactListFunnelStage.CONVERSION, timeRange, attributionView, opts = {}, status = Object.keys(EntityStatusMap), hasListsClientMigrationGate = false) {
    const contactsUrl = `ads/v1/${getListsClientEndpointPath(hasListsClientMigrationGate)}/all-networks`;

    if (typeof status === 'string') {
      status = [getContactsStatus(status)];
    } else if (!Array.isArray(status)) {
      status = status.map(s => getContactsStatus(s)).toJS();
    }

    return handleContactListCreationRequest(Client.apiRequest(contactsUrl, {
      type: 'PUT',
      query: Object.assign({}, opts, {}, calculateTimeRange(timeRange), {
        funnelStage,
        status,
        attributionType: attributionView
      })
    }), opts.listName);
  },

  fetchContactLists(q = '') {
    const query = {
      q,
      sortBy: 'LIST_CREATED',
      direction: 'DESC',
      includeTotal: true,
      offset: 0,
      count: 25
    };
    return Client.apiRequest('contactslistseg/v1/segment-ui/all', {
      query
    });
  },

  fetchContactListInboundDB(query = '') {
    const data = {
      query,
      count: 100,
      offset: 0,
      fetchAllProperties: false,
      properties: ['hs_list_id', 'hs_list_size', 'hs_list_name'],
      listFilterProperties: {
        objectTypeId: '0-1',
        processingTypes: [],
        listIds: [],
        contactIds: [],
        teamIds: []
      },
      includePrivate: false
    };
    return Client.apiRequest('inbounddb-lists/v1/segments-ui/searchLists', {
      type: 'POST',
      data
    });
  },

  fetchSubmissionCount(vids) {
    return Client.apiRequest('contacts/v3/contacts/batch/', {
      query: {
        id: vids,
        includeFormSubmissions: true
      }
    });
  }

};